/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/Contact/Content/Phones/Phone"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let contactPhones0PhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'contact',
path: 'phones.[0].phone.number',
format: fromFormat.phoneNumberUS,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let contactPhonesValueData = fromData.useDataValue({ viewPath,
context: 'contact',
path: 'phones',
})
let constantData = 1
let aggregateData = fromAggregate.lengthGreaterThan(contactPhonesValueData, constantData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral900}
 data="contact.phones.[0].phone.number"
 format="/Data/format.js phoneNumberUS"
 text={contactPhones0PhoneNumberValueData}
/>
<fromFlow.When is={aggregateData}>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 height="12px"
 width="12px"
 fill2={dtColorsNeutral700}
 data="contact.phones"
 data={1}
 aggregate="/Data/aggregate.js lengthGreaterThan"
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}